import React from 'react';
import {
  Item as StatelyItem,
  ItemProps as StatelyItemProps,
} from 'react-stately';

export interface ItemProps<T> extends StatelyItemProps<T> {
  icon?: React.ReactNode;
}

const Item = StatelyItem as <T>(
  props: ItemProps<T>,
) => React.ReactElement | null;

export default Item;
